import { Switch } from "@material-ui/core";
import React from "react";
import { Spinner } from "reactstrap";

const ReportTable = ({
  subjects,
  students,
  isPercent,
  reportValues,
  selectAllStudents,
  isStudentsLoading,
  setStudents,
  setSelectAllStudents,
  setIsPercent,
}) => {
  //handleSelectAllStudent
  const handleSelectAllStudents = (e) => {
    const { checked } = e.target;

    setSelectAllStudents(checked);

    const updatedStudents = students?.map((item) => ({
      ...item,
      checked,
    }));

    setStudents(updatedStudents);
  };

  //handleSelectStudent
  const handleSelectStudent = (e, studentId) => {
    const { checked } = e.target;

    setStudents((prev) => {
      const updatedStudents = prev.map((item) =>
        item.id === studentId ? { ...item, checked } : item,
      );

      const allStudentSelected = updatedStudents.every((item) => item.checked);

      setSelectAllStudents(allStudentSelected);

      return updatedStudents;
    });
  };

  return (
    <div className="arr-table-container">
      <table className="arr-table">
        <thead>
          <tr>
            <th rowSpan={2}>
              <input
                className="checkbox"
                type="checkbox"
                checked={selectAllStudents}
                onChange={handleSelectAllStudents}
              />
            </th>
            <th rowSpan={2}>S.No.</th>
            <th rowSpan={2}>Student Name</th>
            <th rowSpan={2}>Symbol No.</th>
            {subjects?.map((item) => (
              <th
                className="text-center"
                colSpan={
                  Number(item?.hasTheory) + Number(item?.hasPractical) + 1
                }
                key={item?.subjectName}
              >
                {item?.subjectName}
              </th>
            ))}
            <th colSpan={isPercent ? 5 : 3}>
              <div
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                }}
                className="flex"
              >
                <p style={{ margin: 0 }}>Result Information</p>
                <div className="flex">
                  <p style={{ margin: 0 }}>GPA</p>
                  <Switch
                    className="arr-switch"
                    checked={isPercent}
                    onClick={() => setIsPercent((prev) => !prev)}
                    inputProps={{
                      "aria-label": "controlled",
                    }}
                  />
                  <p style={{ margin: 0 }}>Percentage</p>
                </div>
                <p
                  style={{
                    textTransform: "none",
                    fontSize: "11px",
                    fontWeight: "normal",
                    margin: 0,
                    padding: "8px",
                  }}
                  className="arr-note"
                >
                  <strong>Note: </strong> Ranks will be calculated and displayed
                  based on {isPercent ? "Percentage" : "GPA"}.
                </p>
              </div>
            </th>
          </tr>
          <tr>
            {subjects?.map((item) => {
              if (item?.hasTheory && item?.hasPractical) {
                return (
                  <React.Fragment key={item?.subjectId}>
                    <th className="text-center">TH</th>
                    <th className="text-center">PR</th>
                    <th className="text-center">Tot</th>
                  </React.Fragment>
                );
              }
              if (item?.hasTheory && !item?.hasPractical) {
                return (
                  <React.Fragment key={item?.subjectId}>
                    <th className="text-center">TH</th>
                    <th className="text-center">Tot</th>
                  </React.Fragment>
                );
              }
              if (!item?.hasTheory && item?.hasPractical) {
                return (
                  <React.Fragment key={item?.subjectId}>
                    <th className="text-center">PR</th>
                    <th className="text-center">Tot</th>
                  </React.Fragment>
                );
              }
            })}
            <th className="text-center">Total Obtained</th>
            <th className="text-center">Rank</th>
            {!isPercent ? (
              <th className="text-center">GPA</th>
            ) : (
              <>
                <th className="text-center">Percent</th>
                <th className="text-center">Result</th>
                <th className="text-center">Division</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {isStudentsLoading ? (
            <tr>
              <td colSpan={isPercent ? 12 : 9}>
                <div className="arr-spinner">
                  <div className="loader">
                    <Spinner size={"md"} color="primary"></Spinner>
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      marginTop: "15px",
                    }}
                  >
                    Please wait !! Processing.....
                  </div>
                </div>
              </td>
            </tr>
          ) : students?.length ? (
            students?.map((student, index) => {
              //get marks for every subject
              const getSubjectMarks = (subjectId) => {
                const studentSubject = student.subjects.find(
                  (sub) => sub.id === subjectId,
                );

                return studentSubject?.studentSubjectAssessment || {};
              };

              const studentReportValues = reportValues?.filter(
                (item) => item.admissionId === student.id,
              )[0];

              return (
                <tr key={student?.id}>
                  <td>
                    <input
                      className="checkbox"
                      type="checkbox"
                      checked={student?.checked}
                      onChange={(e) => handleSelectStudent(e, student?.id)}
                    />
                  </td>
                  <td>{index + 1}</td>
                  <td>{student?.people?.name}</td>
                  <td>
                    {student?.symbolNo ?? student?.people?.symbolNo ?? "-"}
                  </td>
                  {subjects?.map((subject) => {
                    const marks = getSubjectMarks(subject.subjectId);

                    const theoryMark = marks.isTheoryAbsent
                      ? "Ab"
                      : (marks.theoryObtainedMarks ?? "-");
                    const practicalMark = marks.isPracticalAbsent
                      ? "Ab"
                      : (marks.practicalObtainedMarks ?? "-");
                    const totalMark =
                      marks.isTheoryAbsent || marks.isPracticalAbsent
                        ? "Ab"
                        : (marks.obtainedMarks ?? "-");
                    return (
                      <React.Fragment key={subject.subjectId}>
                        {subject?.hasTheory && (
                          <td className="text-center">{theoryMark}</td>
                        )}
                        {subject?.hasPractical && (
                          <td className="text-center">{practicalMark}</td>
                        )}
                        <td className="text-center">{totalMark}</td>
                      </React.Fragment>
                    );
                  })}
                  <td style={{ textAlign: "center" }}>
                    {studentReportValues?.values?.obtainedMarks ?? "-"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {(isPercent
                      ? studentReportValues?.values?.markRank
                      : studentReportValues?.values?.gpaRank) ?? "-"}
                  </td>
                  {isPercent ? (
                    <>
                      <td style={{ textAlign: "center" }}>
                        {Math.round(studentReportValues?.values?.percent * 10) /
                          10 || "-"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {studentReportValues?.values?.result ?? "-"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {studentReportValues?.values?.division ?? "-"}
                      </td>
                    </>
                  ) : (
                    <>
                      <td style={{ textAlign: "center" }}>
                        {studentReportValues?.values?.finalGrade ?? "-"}
                      </td>
                    </>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td style={{ textAlign: "center" }} colSpan={50}>
                No Student Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
